import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const VEHICLE_TYPE_LABELS: Record<string, string> = {
  sedan: 'Sedan',
  suv: 'SUV',
  hatchback: 'Hatchback',
};

export function getVehicleTypeLabel(code: string | null | undefined): string {
  if (!code) return 'Any Vehicle';
  return VEHICLE_TYPE_LABELS[code] || code.charAt(0).toUpperCase() + code.slice(1);
}
